import React, {useEffect,useState, useContext, useRef} from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import {FormValidator, useFormValidator, Inputs, Scrollable, Message} from 'coaz-ui';
import client from '../client';

const AddUserType = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [userType,setUserType] = useState({});
    const [criteriaPaths,setCriteriaPaths] = useState([]);
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const {request,errorMessage} = client;
    const submit = async (e) => {
        try {
            const response = await request('POST', 'usertypes', userType);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'name',
            type:'text', 
            name:'name',
            value:userType && userType.name?userType.name:'',   
            placeholder:'Enter name...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Tariff Applicable',
            type:'checkbox',
            name:'tariffApplicable',
            value:userType?userType.tariffApplicable:false,   
            onChange:(e) => {
                setUserType({...userType,tariffApplicable: !userType.tariffApplicable});
            }
        },
        {
            label:'Criteria paths',
            type:'select',
            options:() => {
                let options = [];
                userType && userType.tariffApplicable && criteriaPaths.map((option,i) => options.push(<option key={i} value={option.id}>{option.id}</option>));
                return options;
            },
            name:'criteriaPathItem', 
            value:userType && userType.criteriaPathItemId?userType.criteriaPathItemId:'',
            disabled:userType && !userType.tariffApplicable,
            onChange:(e) => handleChange(e,onCriteriaPath)
        }
    ]

    const onChange = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUserType({...userType, [e.target.name]: null});
        } else {
            setUserType({...userType, [e.target.name]: value});
        }
    }

    const onCriteriaPath = (e) => {
        if(e.target.value === '') {
            setUserType({...userType, criteriaPathItemId: null});
        } else {
            let value = criteriaPaths.find((path) => {return path.id == e.target.value});
            setUserType({...userType, criteriaPathItemId: value.id});
        }
    }

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        setLoading && setLoading(true);
        request('GET','criteriapathitems')
        .then((response) => {
            if(response && response.length > 0) {
                setCriteriaPaths(response);
                setUserType({...userType, criteriaPathItemId: response[0].id});
            } else {
                setCriteriaPaths([]);
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            setLoading && setLoading(false);
        })
    },[]);

    return (
        <FormValidator>
            <div className='w-full h-auto shrink-0'>
                <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
            </div>
        </FormValidator>
      )
}

export default AddUserType